/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillOverridesControllerRemoveMutationResponse, SkillOverridesControllerRemovePathParams } from "../../models/skillOverridesController/SkillOverridesControllerRemove";

function getSkillOverridesControllerRemoveUrl(id: SkillOverridesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/skill-overrides/${id}` as const }  
  return res
}

/**
 * @summary Delete a skill override
 * {@link /api/v1/skill-overrides/:id}
 */
export async function skillOverridesControllerRemove(id: SkillOverridesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillOverridesControllerRemoveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getSkillOverridesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}